import { render, staticRenderFns } from "./UserInjuryDelete.vue?vue&type=template&id=0cd9455a&"
import script from "./UserInjuryDelete.vue?vue&type=script&lang=js&"
export * from "./UserInjuryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports